var tables = $(".apo-row table").not('.clone').each(function () {
    var table = $( this )
    table.wrap("<div class='table-scroll'></div>")
    table.wrap("<div class='table-wrap'></div>")
    table.clone()
        .appendTo( table.parent().parent() )
        .addClass('clone')
})
